document.addEventListener('change', (event) => {
    const simpleSelect = event.target.closest('.simple-select');
    if (simpleSelect && event.target.tagName === 'SELECT') {
        window.location = event.target.value;
    }
});